import styled from 'styled-components'
import theme, {colors} from '../../../styles/theme'
import {Tooltip, tooltipClasses, TooltipProps} from '@mui/material'

export const ProgressBox = styled.div<{$isCard: boolean}>`
  display: flex;
  align-items: center;

  ${({$isCard}) => ($isCard ? `padding: 0;` : `padding: 16px 24px;`)}

  && button {
    min-width: 150px !important;
    height: 40px;
    margin-left: auto;
  }

  ${theme.breakpoints.down('sm')} {
    flex-flow: column;

    && button {
      width: 100% !important;
      margin-left: 0;
      margin-top: 16px;
    }

    ${({$isCard}) => ($isCard ? `padding: 0;` : `padding: 16px;`)}
  }
`

export const ProgressFlexBox = styled.div`
  display: flex;
  flex-flow: column;
  width: 100%;
`

export const TitleFlexBox = styled.div<{$isCard: boolean}>`
  display: flex;
  align-items: center;

  ${({$isCard}) => ($isCard ? `gap: 8px;` : `gap: 16px;`)}
`

export const StyledIcon = styled.img<{$isDivisionComplete?: boolean}>`
  width: 40px;
  height: 40px;

  ${({$isDivisionComplete}) => ($isDivisionComplete ? `opacity: 0.25;` : ``)}
`

export const Title = styled.h4<{$isDivisionComplete?: boolean}>`
  margin: 0;
  padding: 0;
  font-size: 16px;
  font-weight: 500;
  ${({$isDivisionComplete}) =>
    $isDivisionComplete
      ? `color: ${colors.bksGray50};`
      : `color: ${colors.bksGray90};`}
`

export const SubTitle = styled.h5<{$isCard: boolean}>`
  margin: 0;
  padding: 0;
  font-size: 16px;
  font-weight: 500;
  color: ${colors.bksGray80};

  ${({$isCard}) =>
    $isCard
      ? `font-size: 14px; margin-top: 0;`
      : `font-size: 16px; margin-top: 16px;`}
`

export const ProgressBarBox = styled.div<{$isCard: boolean}>`
  display: flex;
  align-items: center;
  color: ${colors.bksGray70};
  width: 100%;
  position: relative;
  font-size: 14px;

  && .MuiLinearProgress-root {
    height: 9px;
    border-radius: 6px;
    margin-right: 10px;
    background-color: #d9d9d9;

    ${({$isCard}) => ($isCard ? `width: 70%;` : `width: 80%;`)}

    @media only screen and (max-width: 1250px) {
      width: 70%;
    }

    span {
      background-color: ${colors.blue1};
    }
  }
`

export const WhiteTooltip = styled(({className, ...props}: TooltipProps) => (
  <Tooltip {...props} classes={{popper: className}} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#fff',
    color: '#000',
    boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '6px',
    marginTop: '8px !important',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#fff',
  },
})

export const TooltipBox = styled.div`
  display: flex;
  flex-flow: column;
  gap: 8px;
  color: ${colors.bksGray80};
  max-width: 318px;
  width: 100%;
  box-sizing: border-box;
  padding: 8px;

  && b {
    font-size: 20px;
  }

  && span {
    font-size: 16px;
    line-height: 24px;
  }
`

export const GuaranteeBox = styled.div`
  display: flex;
  padding: 8px 0;
`

export const GuaranteeText = styled.p`
  margin: 0;
  padding: 0;
  font-size: 12px;
  color: ${colors.bksGray60};
  display: flex;
  align-items: center;
  gap: 4px;

  && img {
    height: 12px;
  }
`

export const ChangeMode = styled.p`
  cursor: pointer;
  width: fit-content;
  margin: 16px 0 0 0;
  padding: 0;
  font-size: 14px;
  color: ${colors.bksGray70};
  && img {
    vertical-align: bottom;
    margin-left: 8px;
  }
`

export const CompletedText = styled.p`
  padding: 0;
  margin: 0;
  display: flex;
  gap: 8px;
  color: ${colors.blue1};
  font-size: 14px;
  font-weight: 600;
  align-items: center;
  justify-content: center;
  width: 150px;
`
export const ButtonBox = styled.div`
  display: flex;
  flex-flow: column;
  gap: 16px;
`
